import { render, staticRenderFns } from "./CardAuthList.vue?vue&type=template&id=a719a1a4&"
import script from "./CardAuthList.vue?vue&type=script&lang=js&"
export * from "./CardAuthList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports